export const updateUtmTagsInUrl = (shareUrl: string, tagName: string, tagNewValue: string) => {
  const url = new URL(shareUrl);
  if (url.searchParams.has(tagName)) {
    url.searchParams.set(tagName, tagNewValue);
  }
  return url.toString();
};
